// extracted by mini-css-extract-plugin
export default {"heading":"FeesPage_heading__fV5sd","content":"FeesPage_content__sUfZ5"};